import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  showForm: boolean = false;
  customerobj: any = {
    customer_type: "Billing"
  };
  customerdata: any[] = [];
  isEdit: boolean = false;
  SelectedIndex: any = "";
  selectedItem: any = {};

  p: number = 1;

  displayAll:boolean=false;
  itemPerPage: any = 10;

  constructor(public _baseService: BaseService, public _config: ConfigService) { }

  ngOnInit() {
    this.getCustomers();

    this.initializeForm();
  }


  initializeForm() {
    this.customerobj = {
      customer_type: "Billing"
    };
   
  }

  add_customer() {
    let postBody: any = {
      "company_name": this.customerobj.company_name,
      "contact_name": this.customerobj.contact_name,
      "mobile": this.customerobj.mobile,
      "email": this.customerobj.email,
      "address": this.customerobj.address,
      "city": this.customerobj.city,
      "state": this.customerobj.state,
      "pincode": this.customerobj.pincode,
      "gstin_no": this.customerobj.gstin_no,
      "customer_type": this.customerobj.customer_type
    };

    if (this.isEdit) {

      postBody.isEditCustomer = true;
      postBody.id = this.selectedItem.id;

      let requestURL = this._config.baseURL + this._config.addCustomer;
      let headerOption = this._baseService.commonheader();
      this._baseService.doPUT(requestURL, postBody, headerOption).subscribe((results: any) => {


        if (results.message)
          this._baseService.showSuccess(results.message);

this.initializeForm();

this.isEdit = false;
this.showForm = false;


        this.getCustomers();
      });



    }
    else {

      postBody.isAddCustomer = true;

      let requestURL = this._config.baseURL + this._config.updateCustomer;
      let headerOption = this._baseService.commonheader();
      this._baseService.doPOST(requestURL, postBody, headerOption).subscribe((results: any) => {

        if (results.message)
          this._baseService.showSuccess(results.message);

          this.initializeForm();

          this.isEdit = false;
          this.showForm = false;
      

        this.getCustomers();
      });


    }
  }

  edit_customer(item: any) {
    this.showForm = true;
    this.isEdit = true;
    this.customerobj = item;
    this.selectedItem = item;
  }

  delete_customer(item: any) {
    // this.customerdata.splice(index, 1);
    let requestURL = this._config.baseURL + this._config.deleteCustomer;
    requestURL = requestURL.replace('{ID}', item.id);
    let headerOption = this._baseService.commonheader();
    this._baseService.doDELETE(requestURL, headerOption).subscribe((results: any) => {

      if (results.message)
        this._baseService.showSuccess(results.message);



      this.getCustomers();
    });
  }

  getCustomers() {
    let requestURL = this._config.baseURL + this._config.getCustomer;
    let headerOption = this._baseService.commonheader();
    this._baseService.doGET(requestURL, headerOption).subscribe((results: any) => {
      this.customerdata = results.data;
    });

  }

}
